import StickyFooter from 'components/StickyFooter/StickyFooter';

export default StickyFooter;
